import { useEffect, useRef, useState } from 'react'
import { useClickOutside } from '@carrent/ui'
import { tasksApi } from '@carrent/api'

/**
 * TaskPicker — выбор задачи для парента/связи.
 * selected = { id, title } | null
 * onChange(task | null)
 * excludeId — ID задачи, которую исключить из выбора (для редактирования — себя)
 */
export function TaskPicker({ selected, onChange, excludeId, placeholder = 'Найти задачу...' }) {
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const ref = useRef(null)

  useClickOutside(ref, () => setOpen(false))

  useEffect(() => {
    if (!open) return
    const t = setTimeout(async () => {
      setLoading(true)
      try {
        const params = { per_page: 10 }
        if (q.trim()) params.q = q.trim()
        const { data } = await tasksApi.list(params)
        let items = data.data?.items || []
        if (excludeId) items = items.filter(x => x.id !== excludeId)
        setResults(items)
      } finally { setLoading(false) }
    }, 250)
    return () => clearTimeout(t)
  }, [q, open, excludeId])

  const pick = task => {
    onChange({ id: task.id, title: task.title })
    setQ(''); setOpen(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {selected ? (
        <div className="card" style={{ padding: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>#{selected.id}</div>
            <div style={{ fontSize: '0.88rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {selected.title}
            </div>
          </div>
          <button onClick={() => onChange(null)} className="btn-icon" title="Убрать">×</button>
        </div>
      ) : (
        <input className="input" placeholder={placeholder}
               value={q} onChange={e => { setQ(e.target.value); setOpen(true) }}
               onFocus={() => setOpen(true)} />
      )}

      {open && !selected && (
        <div className="card" style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
          maxHeight: 280, overflowY: 'auto', marginTop: 4, padding: 0,
        }}>
          {loading ? (
            <div className="text-muted text-center" style={{ padding: 12 }}>Поиск...</div>
          ) : results.length === 0 ? (
            <div className="text-muted text-center" style={{ padding: 12 }}>Задач не найдено</div>
          ) : results.map(t => (
            <div key={t.id} onClick={() => pick(t)}
              style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              <div className="text-muted" style={{ fontSize: '0.7rem' }}>#{t.id} · {t.status_label}</div>
              <div style={{ fontSize: '0.85rem' }}>{t.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
